import type { SVGProps } from 'react';
const DawnFlagHK = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-HK_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-HK_svg__a)">
      <path fill="#F0371D" d="M0 16h22V0H0z" />
      <path
        fill="#fff"
        d="M10.988 6.517c.756-.645.802-.79.983-1.357.06-.19.018-.346-.032-.53-.073-.265-.162-.588.02-1.157-.826-.273-1.785.414-2.142 1.535-.358 1.12.021 2.25.847 2.523.148.049.131.014.086-.082-.079-.168-.244-.522.238-.932M9.42 7.694c-.369-.932-.489-1.02-.964-1.372-.158-.117-.317-.124-.504-.132-.27-.011-.6-.026-1.075-.377-.51.715-.164 1.856.772 2.549s2.108.674 2.618-.04c.092-.129.054-.124-.05-.11-.18.024-.562.076-.797-.518m4.722.51c-.587 0-.735 0-1.572-.534-.532-.34-.811-.07-.944.058-.075.073-.103.1-.103-.058 0-.884.938-1.6 2.095-1.6s2.095.716 2.095 1.6c-.587 0-.862.186-1.087.338-.156.106-.288.195-.484.195m0-1.004a.264.264 0 0 1-.262.267.264.264 0 0 1-.262-.267c0-.147.117-.267.262-.267s.262.12.262.267m-2.16 2.36c-.239.974-.193 1.118-.012 1.686.06.19.185.29.332.41.212.17.47.379.652.947.825-.273 1.205-1.402.847-2.523-.357-1.12-1.316-1.808-2.142-1.535-.148.05-.114.068-.022.119.16.088.499.275.346.896m.925 1.377a.26.26 0 0 1-.33-.172.27.27 0 0 1 .168-.336.26.26 0 0 1 .33.172c.045.14-.03.29-.168.335m-2.871-1.362c-.985.069-1.105.158-1.58.509-.158.117-.213.269-.279.448-.094.258-.21.573-.684.924.51.715 1.683.733 2.619.04.936-.692 1.281-1.833.771-2.548-.091-.128-.098-.09-.117.015-.033.183-.103.568-.73.612m-1 1.32a.27.27 0 0 1 .057-.372.26.26 0 0 1 .366.059.27.27 0 0 1-.058.372.26.26 0 0 1-.365-.059M7.878 7.135a.26.26 0 0 1 .366-.06.27.27 0 0 1 .058.373.26.26 0 0 1-.366.06.27.27 0 0 1-.058-.373m3.156-2.284a.27.27 0 0 1 .168.336.26.26 0 0 1-.33.171.27.27 0 0 1-.168-.336.26.26 0 0 1 .33-.171"
      />
    </g>
  </svg>
);
export default DawnFlagHK;
